import { useMoralis } from 'react-moralis';
import { useAccount } from '../contexts/AccountContext';

export function useUser() {
  const moralis = useMoralis();
  const { account, logout, playfab, errorMessage, ethereum } = useAccount();
  return { moralis, account, logout, playfab, errorMessage, ethereum };
}

export type UserContext = {};
